import React, { useContext, useMemo, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { Position } from 'src/types/ViewModel/Stowage/Position';

type StowageLayoutContextType = {
    rightViewWidth: number | null;
    setRightViewWidth: (width: number | null) => void;
    rightViewHeight: number | null;
    setRightViewHeight: (width: number | null) => void;
    tankplanViewWidth: number | null;
    setTankplanViewWidth: (width: number | null) => void;
    tankplanViewHeight: number | null;
    setTankplanViewHeight: (width: number | null) => void;
    portalRootHeight: number;
    setPortalRootHeight: (height: number) => void;
    mouseClickPosition: Position | null;
    setMouseClickPosition: (pos: Position | null) => void;
    tankPlanWindowResized: string | null;
    setTankPlanWindowResized: (nr: string | null) => void;
    isLeftPanelHidden: boolean | null;
    setIsLeftPanelHidden: (isVisible: boolean | null) => void;
    isFilterPanelOpen: boolean | null;
    setIsFilterPanelOpen: (isVisible: boolean | null) => void;
    isTankPlanFilterPanelOpen: boolean | null;
    setIsTankPlanFilterPanelOpen: (isVisible: boolean | null) => void;
};

export const StowageLayoutContext = React.createContext<StowageLayoutContextType>(undefined!);

export const StowageLayoutProvider = ({ children }: ContextProps) => {
    const [rightViewWidth, setRightViewWidth] = useState<number | null>(null);
    const [rightViewHeight, setRightViewHeight] = useState<number | null>(null);
    const [tankplanViewWidth, setTankplanViewWidth] = useState<number | null>(null);
    const [tankplanViewHeight, setTankplanViewHeight] = useState<number | null>(null);
    const [portalRootHeight, setPortalRootHeight] = useState<number | null>(null);
    const [mouseClickPosition, setMouseClickPosition] = useState<Position | null>(null);
    const [tankPlanWindowResized, setTankPlanWindowResized] = useState<string | null>(null);
    const [isLeftPanelHidden, setIsLeftPanelHidden] = useState<boolean | null>(false);
    const [isFilterPanelOpen, setIsFilterPanelOpen] = useState<boolean | null>(false);
    const [isTankPlanFilterPanelOpen, setIsTankPlanFilterPanelOpen] = useState<boolean | null>(false);

    const value = useMemo(
        () => ({
            rightViewWidth,
            setRightViewWidth,
            rightViewHeight,
            setRightViewHeight,
            tankplanViewWidth,
            setTankplanViewWidth,
            tankplanViewHeight,
            setTankplanViewHeight,
            portalRootHeight,
            setPortalRootHeight,
            mouseClickPosition,
            setMouseClickPosition,
            tankPlanWindowResized,
            setTankPlanWindowResized,
            isLeftPanelHidden,
            setIsLeftPanelHidden,
            isFilterPanelOpen,
            setIsFilterPanelOpen,
            isTankPlanFilterPanelOpen,
            setIsTankPlanFilterPanelOpen,
        }),
        [
            rightViewWidth,
            rightViewHeight,
            tankplanViewWidth,
            tankplanViewHeight,
            portalRootHeight,
            mouseClickPosition,
            tankPlanWindowResized,
            isLeftPanelHidden,
            isFilterPanelOpen,
            isTankPlanFilterPanelOpen,
        ],
    );

    return <StowageLayoutContext.Provider value={value}>{children}</StowageLayoutContext.Provider>;
};

export const useStowageLayoutStore = () => useContext(StowageLayoutContext);
